import { render, staticRenderFns } from "./GroupMoveLayer.vue?vue&type=template&id=13da9e2c&scoped=true"
import script from "./GroupMoveLayer.vue?vue&type=script&lang=js"
export * from "./GroupMoveLayer.vue?vue&type=script&lang=js"
import style0 from "./GroupMoveLayer.vue?vue&type=style&index=0&id=13da9e2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13da9e2c",
  null
  
)

export default component.exports